import AutoCompleteInput from "../../common/AutoCompleteInput";
import ControlledAutoCompleteInput from "../../common/ControlledAutoCompleteInput";
import ControlledCurrencyInputField from "../../common/ControlledCurrencyInputField";
import ControlledSelectForm from "../../common/ControlledSelectForm";
import DatePickerField from "../../common/DatePickerField ";
import Input from "../../common/Input";
import ControlledInput from "../../common/InputWithUpdatingState";
import SelectForm from "../../common/SelectForm";
import TimePickerField from "../../common/TimePicker";
import DefineList from "../DefineList/DefineList";
import Spinner from "../spinner/Spinner";

const neccessoryTools = [
  { title: "دوربین" },
  { title: "کلاه نقابدار" },
  { title: "زیرانداز" },
  { title: "کوله پشتی" },
  { title: "قمقمه آب" },
  { title: "ظروف شخصی" },
  { title: "کارت ملی" },
  { title: "دمپایی" },
  { title: "مسواک" },
  { title: "چراغ قوه" },
  { title: "باتوم پیاده روی" },
  { title: "بالش گردنی" },
  { title: "فلاسک" },
  { title: "کرم ضدآفتاب" },
  { title: "عینک آفتابی" },
  { title: "لباس گرم" },
  { title: "دفترچه بیمه" },
  { title: "کفش پیاده روی" },
  { title: "کارت شناسایی" },
  { title: "شناسنامه" },
  { title: "داروهای شخصی" },
  { title: "وسایل بهداشت فردی" },
  { title: "کیسه خواب" },
  { title: "قاشق و چنگال" },
  { title: "پتو سفری" },
  { title: "چتر" },
];

const UpdateTourFormFirstStep = ({
  formik,
  hardshipLevelOptions,
  activityRateOptions,
  wehicleOptions,
  stayingTimeOptions,
  suggestedToolsList,
  suggestedToolsListHandler,
  requierdToolsList,
  requierdToolsListHandler,
  suggestedToolsListRemoveHandler,
  requierdToolsListRemoveHandler,
  mealOptions,
  initMoveTime,
  initReturnTime,
  chnageTourHandler,
  nextStepFlag,
  prevStepTab,
}) => {
  const goNextStep = () => {
    nextStepFlag(true);
  };
  const goPrevStep = () => {
    prevStepTab();
  };
  return (
    <>
      <div className="flex w-1/2 md:w-1/3 px-3">
        <TimePickerField
          formik={formik}
          name="MoveTime"
          label="زمان حرکت"
          time={initMoveTime}
          chnageTourHandler={chnageTourHandler}
          reqiuerd={true}
        />
      </div>
      <div className="flex w-1/2 md:w-1/3 px-3">
        <TimePickerField
          formik={formik}
          name="ReturnTime"
          label="زمان بازگشت"
          time={initReturnTime}
          chnageTourHandler={chnageTourHandler}
          reqiuerd={true}
        />
      </div>
      <div className="flex w-1/2 md:w-1/3 px-3">
        <ControlledInput
          formik={formik}
          name="DeparturePlaceSR"
          label="محل حرکت"
          type="text"
          chnageTourHandler={chnageTourHandler}
          reqiuerd={true}
        />
      </div>
      <div className="flex w-1/2 md:w-1/3 px-3">
        <ControlledSelectForm
          formik={formik}
          name="DifficultyLevelSR"
          label="درجه سختی"
          options={hardshipLevelOptions}
          chnageTourHandler={chnageTourHandler}
          reqiuerd={true}
        />
      </div>
      <div className="flex w-1/2 md:w-1/3 px-3 text-sm">
        <ControlledSelectForm
          formik={formik}
          name="ActivityRate"
          label="میزان فعالیت"
          options={activityRateOptions}
          chnageTourHandler={chnageTourHandler}
          reqiuerd={true}
        />
      </div>
      <div className="flex w-1/2 md:w-1/3 px-3">
        <ControlledSelectForm
          formik={formik}
          name="Meal"
          label="وعده غذایی"
          options={mealOptions}
          chnageTourHandler={chnageTourHandler}
          reqiuerd={true}
        />
      </div>
      <div className="flex w-1/2 md:w-1/3 px-3">
        <ControlledSelectForm
          formik={formik}
          name="VehicleTypeSR"
          label="وسیله نقلیه"
          options={wehicleOptions}
          chnageTourHandler={chnageTourHandler}
          reqiuerd={true}
        />
      </div>
      <div className="flex w-1/2 md:w-1/3 px-3">
        <ControlledSelectForm
          formik={formik}
          name="StayTimeSR"
          label="مدت تور"
          options={stayingTimeOptions}
          chnageTourHandler={chnageTourHandler}
          reqiuerd={true}
        />
      </div>
      <div className="flex w-full md:w-1/3 px-3 mb-3 md:mb-0">
        <DefineList
          name="RequiredStuffSR"
          label="لوازم ضروری"
          formik={formik}
          list={requierdToolsList}
          setList={requierdToolsListHandler}
          removeList={requierdToolsListRemoveHandler}
          suggested={neccessoryTools}
          mainColor="orangeKite"
          reqiuerd={false}
        />
      </div>
      <div className="flex w-full md:w-1/3 px-3 mb-3 md:mb-0">
        <DefineList
          name="RecommendedStuffSR"
          label="لوازم پیشنهادی"
          formik={formik}
          list={suggestedToolsList}
          setList={suggestedToolsListHandler}
          removeList={suggestedToolsListRemoveHandler}
          suggested={neccessoryTools}
          reqiuerd={false}
        />
      </div>

      <div className="w-full flex justify-between h-12 mx-2 mt-6">
        <div className="flex w-1/2">
          <button
            onClick={goPrevStep}
            className="block w-auto mt-2 disabled:bg-slate-400 disabled:text-white disabled:cursor-not-allowed bg-red-400 text-white text-center rounded-md py-2 px-4"
          >
            مرحله قبل
          </button>
        </div>
        <div className="flex w-1/2 justify-end gap-2">
          <button
            type="submit"
            disabled={!formik.isValid}
            className="block w-24 mt-2 disabled:bg-slate-400 disabled:text-white disabled:cursor-not-allowed bg-darkGreenKite text-white text-center rounded-md py-2 px-4"
          >
            {formik.isSubmitting ? <Spinner /> : "ذخیره"}
          </button>
          <button
            type="submit"
            onClick={goNextStep}
            disabled={!formik.isValid}
            className="block w-30 mt-2 text-xs disabled:bg-slate-400 disabled:text-white disabled:cursor-not-allowed bg-darkGreenKite text-white text-center rounded-md py-2 px-4"
          >
            {formik.isSubmitting ? <Spinner /> : "ذخیره و ادامه"}
          </button>
        </div>
      </div>
    </>
  );
};

export default UpdateTourFormFirstStep;
